import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['toggle', 'registrationSource'];

  connect() {
    if (window.location.href.includes('app/rejestracja_spolki')) {
      this.switchTab('copartnership');
    } else {
      this.switchTab('self_employed');
    }
  }

  switch(event) {
    event.preventDefault();
    const { tabId } = event.currentTarget.dataset;
    this.switchTab(tabId);
  }

  switchTab(tabId) {
    document.querySelectorAll('#self_employed, #copartnership').forEach((div) => {
      div.classList.add('hide');
    });

    const selectedDiv = document.getElementById(tabId);
    if (selectedDiv) {
      selectedDiv.classList.remove('hide');
    }

    this.toggleTargets.forEach((toggle) => {
      const isActive = toggle.dataset.tabId === tabId;
      toggle.classList.toggle('active-toggle', isActive);
      toggle.classList.toggle('bg-white', isActive);
      toggle.classList.toggle('text-blue-600', isActive);
      toggle.classList.toggle('bg-transparent', !isActive);
      toggle.classList.toggle('text-gray-800', !isActive);
    });

    if (this.hasRegistrationSourceTarget) {
      const sourceValue = tabId === 'self_employed' ? 'ambassador_self_employed' : 'ambassador_copartnership';
      this.registrationSourceTarget.value = sourceValue;
    }
  }
}
